<template>
  <!--div class="debug">
        <p>customer-form:</p>
        <p>selectedCustomerId = {{ selectedCustomerId }}</p>       
    </div-->
  <FormListbox
    :name="'Select a customer:'"
    v-model:selected="selectedCustomerId"
    :options="options"
    :displayOptions="displayOptions"
  ></FormListbox>
  <FormBtn :name="'load customer'" @clicked="loadCustomer"></FormBtn>

  <MyForm v-if="customer" :title="'Customer Details'">
    <template v-slot:fields>
      <!--FormListbox :name="'Customer Listbox Test'" :options="allCustomers" :displayOptions="allCustomers.map(cust=>cust.invoiceName)" :displayField="'invoiceName'" v-model:selected="selectedCustomer"></FormListbox>-->

      <!--input type='list' list='listId1'>
            <datalist id="listId1">
                <option v-for="(item, index) in allCustomers.map(cust=>cust.id)" :key="index" :value="item" :selected="item.id == selected">{{ index}}
            </option>
            </datalist-->
      <Form-input
        v-model="customer.id"
        :readonly="true"
        :disabled="true"
        :name="'customer id:'"
      ></Form-input>
      <Form-input
        v-model="customer.created_by"
        :readonly="true"
        :disabled="true"
        :name="'created by:'"
      ></Form-input>
      <Form-input
        v-model="customer.created_on"
        :readonly="true"
        :disabled="true"
        :name="'created on:'"
      ></Form-input>
      <Form-input
        v-model="customer.modified_on"
        :readonly="true"
        :disabled="true"
        :name="'modified on:'"
      ></Form-input>

      <Form-input v-model="customer.name" :name="'name:'"></Form-input>
      <Form-input v-model="customer.companyName" :name="'company name:'"></Form-input>
      <Form-input v-model="customer.invoiceName" :name="'invoice name:'"></Form-input>

      <Form-email v-model="customer.email" :name="'email:'"></Form-email>
      <FormTextArea v-model="customer.notes" :name="'notes:'"></FormTextArea>
      <p>Project count : {{ customerProjects.length }}</p>
      <p>Invoice count : {{ customerInvoices.length }}</p>
      <p>Postech count : {{ customerPostechs.length }}</p>
    </template>

    <template v-slot:buttons>
      <div class="btn-footer">
        <FormBtn :name="'Save Changes'" @clicked="submitForm"></FormBtn>
        <FormBtn :name="'Revert Changes'" @clicked="revertForm"></FormBtn>
        <FormBtn
          v-if="customerProjects.length < 1 && customerInvoices.length < 1 && customerPostechs.length < 1"
          :name="'Delete Customer'"
          @clicked="deleteCustomer"
          :class="'red'"
        ></FormBtn>
      </div>
    </template>
  </MyForm>
  <div class="debug">
    <p>AllCustomers ref length = {{ allCustomers.length }}</p>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue'
import type { Customer } from '@/types/types'
import { useCustomerStore, useAlertStore, useUserStore } from '@/stores'
import router from '@/router'
import { storeToRefs } from 'pinia'
import {
  FormSelect,
  MyForm,
  FormTextArea,
  FormInput,
  FormEmail,
  FormBtn,
  FormListbox
} from '@/components/form'
import CustomerSelect from '@/components/Customer-select.vue'
import CustomerListbox from '@/components/Customer-listbox.vue'

//const selectedCustomerId=ref(1);
const selectedCustomerId = defineModel('selectedCustomerId')
//const selectedCustomer= defineModel('selectedCustomer');

const customerStore = useCustomerStore()
const { allCustomers } = storeToRefs(customerStore)
//const allCustomers = ref({});
//allCustomers.value = await customerStore.getAllCustomers()
//selectedCustomer.value = allCustomers.value[0];
selectedCustomerId.value = allCustomers.value[0].id

const options = computed(() => {
  return allCustomers.value.map((cust) => {
    // return {id : cust.id, invoiceName: cust.invoiceName};
    return cust.id
  })
})

const displayOptions = computed(() => {
  return allCustomers.value.map((cust) => {
    return cust.invoiceName
  })
})

const customer = ref(allCustomers.value[1])

function loadCustomer() {
  customer.value = allCustomers.value.find((cust) => cust.id == selectedCustomerId.value)
}

const customerProjects = computed(() => {
  return customer.value.projects
})

const customerInvoices = computed(() => {
  return customer.value.invoices
})

const customerPostechs = computed(()=>{
  return customer.value.postechs;
})

//update customer
async function submitForm() {
  console.log('CustomerForm View.submitForm()...')
  customerStore.update(customer.value)
}

async function revertForm() {
  console.log('CustomerForm View.revertForm()...')
  router.push('/customers/manage')
  //await fetchCustomer();
  //customer.value = await customers.getById(customerId);
}

async function deleteCustomer() {
  console.log('customer form delete...')
  const alert = useAlertStore()

  const msg = await customerStore.remove(customer.value.id) //TODO need to return the ID
  console.log('delete customer from backend, returns : ' + JSON.stringify(msg))
  const objId = msg.id
  alert.success('removed customer ' + msg)
  //delay push for alert
  setTimeout(() => {
    alert.clear()
    //push to project details
    router.back() //go back in history
    //router.push(`/customers/`); //${objId}`)
  }, 2000)
}
</script>

<style lang="css" scoped>
/*.btn-footer {
  display: flex;
  flex-direction: row-reverse;
  gap: 1rem;
}*/

.emails-div {
  display: flex;
  flex-direction: row;
  gap: 5rem;
}
</style>
